import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeLocalidadesHome = () => {
  const localidadesSection = document.getElementById("localizacao-home");
  if (!localidadesSection) return;

  // Inicia o Swiper
  const swiper = new Swiper('.my-swiper-localidades', {
    slidesPerView: 6,
    spaceBetween: 16,
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
      },
      640: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 6,
      }
    }
  });

  const iframe = document.getElementById('map-frame');
  const slides = document.querySelectorAll('.swiper-slide');

  function setActive(slide) {
    slides.forEach(el => el.classList.remove('active'));
    slide.classList.add('active');
  }

  slides.forEach((slide, index) => {
    const button = slide.querySelector('.go-button');

    // Clique no card
    slide.addEventListener('click', (e) => {
      if (e.target === button) return;

      setActive(slide);

      const location = slide.getAttribute('data-location');
      if (location) {
        const query = decodeURIComponent(location);
        const embedUrl = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
        iframe.src = embedUrl;
      }
    });

    // Clique no botão "COMO CHEGAR"
    if (button) {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const link = slide.getAttribute('data-link');
        if (link) {
          window.open(link, '_blank');
        }
      });
    }

    // Ativa o primeiro card ao carregar
    if (index === 0) {
      setActive(slide);
      const firstLocation = slide.getAttribute('data-location');
      if (firstLocation) {
        const query = decodeURIComponent(firstLocation);
        iframe.src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
      }
    }
  });
};

export default initializeLocalidadesHome;
